import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";

import Select from "react-select";
import Model from "../Model";
import { useTranslation } from "react-i18next";
import CustomPhoneInput from "../CountryCode";
const AddFarmerModel = ({
  AddSubAgentLoading,
  postFarmerUser,

  setOpenUploadModel,

  data,
  // companyArr,
}) => {

  const { t, i18n } = useTranslation();
  const InitialValues = {

  };
  // console.log(data)
  const SubmitHandler = (values) => {

    postFarmerUser(values);
  };

  const genderOption = [
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
  ];

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setOpenUploadModel}>
      <Title>Add Farmer </Title>

      {AddSubAgentLoading && <Loading />}

      {!AddSubAgentLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="name" >Name</Label>
                <FieldWrapper>
                  <Field name="name" id="name" type="text" autoComplete="off" required />
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="phone">Phone Number</Label>
                <Field
                  name="phone"
                  render={({ field, form }) => (
                    <CustomPhoneInput field={field} form={form} />
                  )}
                />
                {/* <FieldWrapper>
                  <Field
                    type="number"

                    maxlength={9}
                    name="phone"
                    id="phone"
                    autoComplete="off"
                    className="truncate"

                  />
                </FieldWrapper> */}
              </InputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="age">Age</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="age"
                      id="age"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="gender">Gender</Label>
                  <FieldWrapper $select={true}>
                    <Field required name="gender" id="gender" autoComplete="off"  >
                      {(props) => (
                        <Select
                          className="w-full h-full"
                          // isMulti
                          required
                          options={genderOption}
                          classNamePrefix="select"

                          onChange={(val) => {
                            props.form.setFieldValue("gender", val.value)
                          }
                          }
                        />
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup>

              </CombineInputGroup>


              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="village">Village</Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="village"
                      id="village"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="district">District</Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="district"
                      id="district"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

              </CombineInputGroup>



            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;


const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center mt-8`;

export default AddFarmerModel;
